import { connect } from 'react-redux';
import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import LoginHOC from '../../../../components/LoginHOC';
import ViewComponent from '../ViewComponent/components/ComponentWrapper';
import Spinner from '../../../../components/Spinner';

class Component extends React.Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    console.log('Props', this.props);
    const { id = null, fieldid = null, optionid = null } = this.props.params;

    if (id !== null && fieldid !== null && optionid !== null) {
      this.props.upsertFieldAnswersOption({
        variables: {
          ID: id,
          Fields: [
            {
              id: fieldid,
              value: optionid,
            }
          ]
        }
      })
        .then(() => this.setState({
          loading: false
        }))
        .catch(err => {
          console.log(err);
        });
    }
  }

  render() {
    return (
      <div>
        {this.state.loading === false && (
          <div className="container">
            <div style={{ padding: '10px 15px' }}>
              {(this.state.loading === false) ? (
                <div style={{
                  marginTop: '30px',
                  padding: '10px 20px',
                  background: '#49b644',
                  color: '#fff',
                  borderRadius: '4px',
                }}>
                  Thanks your feedback was recorded. Please continue with the rest of the survey.
              </div>
              ) : null}
            </div>
          </div>
        )}
        {this.state.loading && (
          <div style={{
            padding: '40px'
          }}>
            <Spinner />
          </div>
        )
        }
        <div>
          {(this.state.loading === false) && <ViewComponent {...this.props} />}
        </div>
      </div >
    )
  }
}


const upsertFieldAnswersOptionMutation = gql`
mutation (
  $ID: Int!
  $Fields: [ComponentFieldInput]
) {
  upsertFieldAnswersOption(ComponentInstanceID: $ID, Fields: $Fields) {
    field_id
    value
    updated_at
  }
}
`;


const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default store => ({
  path: 'component/oneclick/:id/:fieldid/:optionid',
  component: LoginHOC(connect(mapStateToProps)(graphql(upsertFieldAnswersOptionMutation, {
    name: 'upsertFieldAnswersOption',
  })(Component))),
});




// WEBPACK FOOTER //
// ./src/routes/modules/routes/OneClick/index.js